import script from "./BlockCallAPI.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockCallAPI.vue?vue&type=script&setup=true&lang=js"

import "./BlockCallAPI.vue?vue&type=style&index=0&id=36becc83&lang=css"

const __exports__ = script;

export default __exports__